import { type UseFormReturn } from 'react-hook-form';

import {
  fetchTemplateOrThrow,
  parseTemplateConfig,
  normalizeSteps,
  buildFormValues,
  normalizeGeneratedSteps,
  buildGeneratedFormValues,
  extractGeneratedSteps,
} from './utils';
import { SessionConfig } from '../../utils/experienceForm/transform';

export {
  fetchTemplateOrThrow,
  parseTemplateConfig,
  normalizeSteps,
  buildFormValues,
  normalizeGeneratedSteps,
  buildGeneratedFormValues,
  extractGeneratedSteps,
};

export function resetAndValidate(
  experienceForm: UseFormReturn<SessionConfig>,
  values: SessionConfig
) {
  experienceForm.reset(values);
  return experienceForm.trigger();
}
